import React from "react";
import "./CreateApplicationDialog.css";
import { Form } from "react-bootstrap";
import CamplaCoreService from "../../../../../../services/CamplaCoreService";
import ValidationHelper from "../../../../../../helpers/ValidationHelper";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";
import BaseDatePicker from "../../../../../../components/baseDatePicker/BaseDatePicker";
import BaseSelect from "../../../../../../components/baseSelect/BaseSelect";

class CreateApplicationDialog extends React.Component {
  constructor(props) {
    super(props);
    this.validationDefinition = {
      name: {
        defaultValue: "",
        rule: ValidationHelper.isNonEmptyString,
      },
      expiration: {
        initValid: true,
        defaultValue: ValidationHelper.yearsFromNow(3),
        rule: (value) => ValidationHelper.isTokenExpirationDate(value),
      },
      options: {
        defaultValue: { departmentId: "", instanceTemplateId: "" },
        initValid: false,
        rule: (value) => ValidationHelper.isApplicationOptions(value),
      },
    };

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition),
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation),
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      this.setState({
        validation: ValidationHelper.getValidation(this.validationDefinition),
      });
    }
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      this.props.onSubmit(validatedData);
    }
  }

  render() {
    const { t } = this.props;

    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        rightButtonCallback={this.onSubmit}
        title={t("Organisation.ApplicationTabbar.CreateDialog.Title")}
        dialogApiError={this.props.dialogApiError}
        leftButtonVariant="black"
        rightButtonVariant="green"
        rightButtonText={t(
          "Organisation.ApplicationTabbar.CreateDialog.Submit"
        )}
        leftButtonText={t("Organisation.ApplicationTabbar.CreateDialog.Cancel")}
        leftButtonCallback={this.onHide}
        rightButtonDisabled={!this.state.validation._isValid}
        body={
          <Form>
            <Form.Group controlId="formClassName">
              <Form.Label>
                {t("Organisation.ApplicationTabbar.CreateDialog.Name")}
              </Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder={t(
                  "Organisation.ApplicationTabbar.CreateDialog.AppNamePlaceholder"
                )}
                value={this.state.validation.name.value}
                isInvalid={!this.state.validation.name.isValid}
                onChange={this.handleChange}
              />
              <Form.Control.Feedback type="invalid">
                {t(
                  "Organisation.ApplicationTabbar.CreateDialog.ValidationError.Name"
                )}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formDateEnd">
              <Form.Label>
                {t("Organisation.ApplicationTabbar.CreateDialog.Expiration")}
              </Form.Label>
              <div>
                <BaseDatePicker
                  name="end"
                  className="form-control"
                  onChange={(d) => {
                    this.handleChange({
                      target: {
                        name: "expiration",
                        value: d,
                      },
                    });
                  }}
                  value={this.state.validation.expiration.value}
                  min={new Date()}
                  isInvalid={!this.state.validation.expiration.isValid}
                />
              </div>
              <Form.Control
                type="hidden"
                isInvalid={!this.state.validation.expiration.isValid}
              />
              <Form.Control.Feedback type="invalid">
                {t(
                  "Organisation.ApplicationTabbar.CreateDialog.ValidationError.Expiration"
                )}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formSelectModuleClass">
              <Form.Label>
                {t("Organisation.ApplicationTabbar.CreateDialog.Departments")}
              </Form.Label>
              <BaseSelect
                isInvalid={
                  !true /* this.state.validation.options.departmentId.isValid */
                }
                options={this.props.departments}
                placeholder={t(
                  "Organisation.ApplicationTabbar.CreateDialog.DepartmentsPlaceholder"
                )}
                isMulti={false}
                onChange={(opt) => {
                  const next = {
                    ...this.state.validation.options.value,
                    departmentId: opt ? opt._id : "",
                  };
                  this.handleChange({
                    target: { name: "options", value: next },
                  });
                }}
                getOptionLabel={(option) =>
                  this.props.getLanguage(option.description)
                }
                getOptionValue={(option) => option._id}
              />
              <Form.Control
                type="hidden"
                isInvalid={
                  false /* !this.state.validation.departments.isValid */
                }
              />
            </Form.Group>

            <Form.Group controlId="formSelectModuleClass">
              <Form.Label>
                {t(
                  "Organisation.ApplicationTabbar.CreateDialog.InstanceTemplates"
                )}
              </Form.Label>
              <BaseSelect
                isInvalid={
                  !true /* this.state.validation.options.departmentId.isValid */
                }
                options={this.props.instanceTemplates}
                placeholder={t(
                  "Organisation.ApplicationTabbar.CreateDialog.InstanceTemplatePlaceholder"
                )}
                isMulti={false}
                onChange={(opt) => {
                  const next = {
                    ...this.state.validation.options.value,
                    instanceTemplateId: opt ? opt._id : "",
                  };
                  this.handleChange({
                    target: { name: "options", value: next },
                  });
                }}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option._id}
              />
              <Form.Control
                type="hidden"
                isInvalid={
                  false /* !this.state.validation.departments.isValid */
                }
              />
            </Form.Group>
          </Form>
        }
      />
    );
  }
}

export default withTranslation()(CreateApplicationDialog);
